import { db } from '@app/icare/client/db'
import { localResultQueryOptions } from '@app/icare/client/db/client/localQueryOptions'
import { jsonObjectFrom } from '@app/icare/db/query/jsonHelpers'
import { AdTeamSchema } from '@app/icare/entities/adTeam/schema/ADTeam'
import type { PatientIdType } from '@app/icare/entities/patient/schema/PatientId'
import { zodObjectRootKeys } from '@pkg/api/query'

export const patientADTeamQueries = {
  forList: (patientId: PatientIdType) =>
    localResultQueryOptions({
      meta: { scope: { patientId: String(patientId), tags: ['patientADTeam'] } },
      query: db
        .selectFrom('patientAdTeam')
        .selectAll()
        .where('patientId', '=', patientId)
        .where('deletedAt', 'is', null)
        .select(eb =>
          jsonObjectFrom(
            eb
              .selectFrom('adTeam')
              .select(zodObjectRootKeys(AdTeamSchema, 'adTeam.'))
              .whereRef('adTeam.id', '=', 'patientAdTeam.toId'),
          ).as('to'),
        )
        .orderBy('activeFrom', 'desc'),
    }),

  forIndex: (patientId: PatientIdType) =>
    localResultQueryOptions({
      meta: { scope: { patientId: String(patientId), tags: ['patientADTeam', 'index'] } },
      query: db
        .selectFrom('patientAdTeam')
        .selectAll()
        .where('patientId', '=', patientId)
        .where('deletedAt', 'is', null)
        .select(eb =>
          jsonObjectFrom(
            eb
              .selectFrom('adTeam')
              .select(zodObjectRootKeys(AdTeamSchema, 'adTeam.'))
              .whereRef('adTeam.id', '=', 'patientAdTeam.toId'),
          ).as('to'),
        )
        .orderBy('activeFrom', 'desc'),
    }),
}
